import { render, staticRenderFns } from "./View.vue?vue&type=template&id=b915e964"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b915e964')) {
      api.createRecord('b915e964', component.options)
    } else {
      api.reload('b915e964', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=b915e964", function () {
      api.rerender('b915e964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/ui-components/spacing/View.vue"
export default component.exports